import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import axios from "axios";
import "./style.css";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  Fade,
  Card,
  CardContent,
} from "@mui/material";
import FormWithDrawer from "./FormWithDrawer";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { getAPI, getHost } from "../../Global";
import Pagination from "./Pagination";
import useApi from "../useApi";

function CrudManager(props) {
  const dataSchema = props.data || {};
  const dataApi = getAPI(props.data.api);
  const [apiData, setApiData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [orderBy, setOrderBy] = useState(""); // Column to sort
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [anchorEls, setAnchorEls] = useState({}); // Updated state for menu anchors
  const [mounted, setMounted] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [previousPage, setPreviousPage] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const updateFormTitle = props.updateFormTitle ? props.updateFormTitle : "";
  const createFormTitle = props.createFormTitle ? props.createFormTitle : "";
  const actionBtnName = props.actionBtnName
    ? props.actionBtnName
    : "Create New Data";
  const createRequired = props.createRequired === false ? false : true;
  const editRequired = props.editRequired === false ? false : true;
  const searchRequired = props.searchRequired === false ? false : true;
  const hideDelete = props.hideDelete === true ? true : false;

  const createField = dataSchema.createField || [];
  const editField = dataSchema.editField || [];
  const showField = dataSchema.showField || [];
  const filters = dataSchema.filters || [];
  const [filterValues, setFilterValues] = useState({});
  const [exactFilters, setExactFilters] = useState(false);
  const manageRecord = true;
  const { Get, Delete, Patch } = useApi();
  let navigate = useNavigate();
  const getData = async () => {
    setSearchQuery("");
    makeApiRequest(buildQueryUrl("", filterValues));
  };

  const makeApiRequest = async (api) => {
    try {
      const result = await Get(api ? api : dataApi);
      setNextPage(result.next);
      setPreviousPage(result.previous);
      setTotalCount(result.count);
      setApiData(result.results);
      setFilteredData(result.results);
    } catch (err) {
      if (err.code == "ERR_BAD_REQUEST") {
        toast.error("Unauthorised access to page, Contact admin for access.");
        navigate("/");
      } else {
        toast.error(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const pageChangeRequest = (url) => {
    if (getPageUrl(url) != null) {
      makeApiRequest(getHost() + getPageUrl(url));
    }
  };

  async function softDelete(data) {
    try {
      await Patch(dataApi, data["id"], { is_deleted: true })
        .then(() => {
          toast.success("Record updated successfully!");
          getData();
        })
        .catch((err) => {
          getData();
          // console.error(err);
          toast.error(err || "Error");
        });
    } catch {
      getData();
      toast.error("Something Went wrong contact Humbingo");
    }
    // axios
    //   .patch(`${dataApi}${data["id"]}/`, {
    //     is_deleted: true,
    //   })
    //   .then((response) => {
    //     toast.success("Record deleted successfully!");
    //     getData();
    //   })
    //   .catch((err) => {
    //     getData();
    //     toast.error("Unable to delete record, try force delete!");
    //   });
  }

  async function restore(data) {
    try {
      await Patch(dataApi, data["id"], { is_deleted: false })
        .then(() => {
          toast.success("Record updated successfully!");
          getData();
        })
        .catch((err) => {
          getData();
          // console.error(err);
          toast.error(err || "Error");
        });
    } catch {
      getData();
      toast.error("Something Went wrong contact Humbingo");
    }
    // axios
    //   .patch(`${dataApi}${data["id"]}/`, {
    //     is_deleted: false,
    //   })
    //   .then((response) => {
    //     toast.success("Record restored successfully!");
    //     getData();
    //   })
    //   .catch((err) => {
    //     getData();
    //     toast.error("Record restore unsuccessful");
    //   });
  }

  async function forceDelete(data) {
    await Swal.fire({
      title: "Data will be removed permanently! Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await Delete(dataApi, data["id"])
            .then(() => {
              toast.success("Record updated successfully!");
              getData();
            })
            .catch((err) => {
              getData();
              // console.error(err);
              toast.error(err || "Error");
            });
        } catch {
          getData();
          toast.error("Something Went wrong contact Humbingo");
        }
        // axios
        //   .delete(`${dataApi}${data["id"]}/`)
        //   .then((response) => {
        //     toast.success("Record deleted successfully!");
        //     getData();
        //   })
        //   .catch((err) => {
        //     toast.error("Unable to force delete record. Contact admin!");
        //     getData();
        //   });
      }
    });
  }

  const getValueFromUrl = (url, parameterName) => {
    try {
      const regex = new RegExp(`${parameterName}=([^&]+)`);
      const match = url.match(regex);
      return match ? match[1] : null;
    } catch {
      return null;
    }
  };

  function getPageUrl(url) {
    let urls = "";
    try {
      const urlObject = new URL(url);
      urls = urlObject.pathname + urlObject.search;
    } catch {
      return null;
    }
    return urls;
  }

  useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (loading && mounted) {
      getData();
    }
  }, [loading, mounted]);

  const handleSearchInputChange = useCallback(
    (() => {
      let timeoutId;
      return (event) => {
        const query = event.target.value;
        setSearchQuery(query);
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          makeApiRequest(buildQueryUrl(query, filterValues));
        }, 300);
      };
    })()
  , [dataApi, filterValues, exactFilters]);

  const buildQueryUrl = (query = searchQuery, currentFilters = filterValues, exact = exactFilters) => {
    const params = new URLSearchParams();
    if (query.trim()) params.set("search", query.trim());
    Object.entries(currentFilters).forEach(([name, value]) => {
      if (value.trim()) params.set(name, value.trim());
    });
    if (exact && filters.length > 0) params.set("exact_search", "true");
    const queryString = params.toString();
    return queryString ? `${dataApi}?${queryString}` : dataApi;
  };

  const handleFilterChange = (name, value) => {
    const nextFilters = { ...filterValues, [name]: value };
    setFilterValues(nextFilters);
    setPage(0);
    setCurrentPage(1);
    makeApiRequest(buildQueryUrl(searchQuery, nextFilters));
  };

  const handleExactToggle = () => {
    const nextExactFilters = !exactFilters;
    setExactFilters(nextExactFilters);
    setPage(0);
    setCurrentPage(1);
    makeApiRequest(buildQueryUrl(searchQuery, filterValues, nextExactFilters));
  };

  const handleSort = (columnKey) => {
    const isAsc = orderBy === columnKey && order === "asc";
    setOrderBy(columnKey);
    setOrder(isAsc ? "desc" : "asc");
    setSortedColumn(columnKey);
  };

  const sortedData = stableSort(filteredData, getComparator(order, orderBy));
  const visibleRows = sortedData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const dateGroupKey = dataSchema.dateGroupKey;
  const now = new Date();
  const todayKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const todayLabel = `Today — ${now.toLocaleDateString(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  })}`;
  const todayRows = visibleRows.filter((row) => String(row[dateGroupKey] || "").slice(0, 10) === todayKey);
  const olderRows = visibleRows.filter((row) => String(row[dateGroupKey] || "").slice(0, 10) !== todayKey);
  const sortDeletedLast = (rows) => [...rows].sort((a, b) => Number(Boolean(a.can_replace)) - Number(Boolean(b.can_replace)));
  const tableGroups = dateGroupKey
    ? [
        { title: todayLabel, rows: sortDeletedLast(todayRows) },
        { title: "Older", rows: sortDeletedLast(olderRows) },
      ]
    : [{ title: "", rows: sortDeletedLast(visibleRows) }];

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const handleMenuClick = (event, rowIndex) => {
    setAnchorEls((prev) => ({
      ...prev,
      [rowIndex]: event.currentTarget,
    }));
  };

  const handleMenuClose = (rowIndex) => {
    setAnchorEls((prev) => ({
      ...prev,
      [rowIndex]: null,
    }));
  };

  return (
    <>
      {loading ? (
        <center>
          <img
            src="./assets/img/loader.gif"
            height="30px"
            width="30px"
            alt="Loading"
          />
        </center>
      ) : (
        <div className="crud-manager">
          <Card
            className="crud-toolbar-card"
          >
            <CardContent className="crud-toolbar-content">
              {createRequired && (
                <FormWithDrawer
                  actionBtnName={actionBtnName}
                  inputFields={createField}
                  api={dataApi}
                  createFormTitle={createFormTitle}
                  refreshData={() => getData()}
                            buttonStyle={{}}
                />
              )}
              {searchRequired && (
                <div className="search-table">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                    placeholder="Search..."
                    className="search-input-table"
                  />
                </div>
              )}
              {filters.map((filter) => (
                <div className="search-table" key={filter.name}>
                  <input
                    type="text"
                    value={filterValues[filter.name] || ""}
                    onChange={(event) => handleFilterChange(filter.name, event.target.value)}
                    placeholder={filter.placeholder || filter.label}
                    aria-label={filter.label}
                    className="search-input-table"
                  />
                </div>
              ))}
              {filters.length > 0 && (
                <Button
                  variant={exactFilters ? "contained" : "outlined"}
                  color="primary"
                  onClick={handleExactToggle}
                  size="small"
                  sx={{ whiteSpace: "nowrap", minHeight: "40px" }}
                >
                  {exactFilters ? "Exact Search" : "Contains Search"}
                </Button>
              )}
            </CardContent>
          </Card>
          {tableGroups.map((tableGroup) => (
          <React.Fragment key={tableGroup.title || "all"}>
          {tableGroup.title && <h3 style={{ margin: "24px 0 8px" }}>{tableGroup.title}</h3>}
          <TableContainer component={Paper} className="crud-table-container">
            <Table aria-label="data table" stickyHeader>
              <TableHead className="crud-table-head">
                <TableRow>
                  {showField.map((th, index) => {
                    const isSorted = orderBy === th.key;
                    const isAsc = orderBy === th.key && order === "asc";
                    return (
                      <TableCell
                        key={index}
                        onClick={() => handleSort(th.key)}
                      >
                        {th.label} {isSorted && (isAsc ? "▲" : "▼")}
                      </TableCell>
                    );
                  })}
                  {manageRecord && actionBtnName !== false && (
                    <TableCell className="crud-action-heading">
                      {!hideDelete ? "Action" : ""}
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableGroup.rows.map((data, rowIndex) => (
                  <TableRow
                    key={rowIndex}
                    style={
                      data.can_replace
                        ? {
                            backgroundColor: "#ffebee",
                            color: "#8b1e2d",
                            opacity: 0.75,
                          }
                        : data.is_disabled
                        ? {
                            backgroundColor: "#e0dfff",
                            borderBottom: "2px dashed orange",
                          }
                        : {}
                    }
                  >
                    {showField.map((field, i) => (
                      <TableCell
                        className="crud-table-cell"
                        key={i}
                        style={{
                          textAlign:
                            field.type === "status" ? "center" : "left",
                          ...(data.can_replace
                            ? { textDecoration: "line-through" }
                            : {}),
                          ...(field.type === "status"
                            ? {
                                padding: "8px",
                              }
                            : {}),
                        }}
                      >
                        {field.type === "status" ? (
                          <div
                            style={{
                              borderRadius: "20px",
                              backgroundColor:
                                field.key === "comparison_status"
                                  ? data[field.key] === "Success"
                                    ? "#4caf50"
                                    : "#f44336"
                                  : data[field.key] === true
                                  ? "#4caf50"
                                  : "#f44336",
                              color: "white",
                              fontWeight: "bold",
                              width: "80px",
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "0 auto",
                            }}
                          >
                            {data[field.key]}
                          </div>
                        ) : field.type === "image" ? (
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() =>
                              props.onViewImage &&
                              props.onViewImage(data[field.key])
                            }
                          >
                            View
                          </Button>
                        ) : typeof data[field.key] === "boolean" ? (
                          data[field.key] ? (
                            "true"
                          ) : (
                            "false"
                          )
                        ) : (
                          data[field.key]
                        )}
                      </TableCell>
                    ))}
                    {manageRecord && actionBtnName !== false && (
                      <TableCell className="crud-table-cell crud-action-cell">
                        {editRequired && (
                          <FormWithDrawer
                            actionBtnName="Edit"
                            inputFields={editField}
                            data={data}
                            api={dataApi}
                            onClick={() => handleMenuClose(rowIndex)}
                            refreshData={() => getData()}
                            buttonStyle={{ fontSize: "12px", padding: "5px" }}
                            buttonVarient="outlined"
                            updateFormTitle={updateFormTitle}
                            submitBtnTitle="Update Data"
                          />
                        )}

                        {props.onResetScreenshot && (
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => props.onResetScreenshot(data.id)}
                            style={{ fontSize: "12px", padding: "5px", marginLeft: "5px" }}
                          >
                            Reset
                          </Button>
                        )}

                        {props.onCorrectScreenshot && (
                          <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            sx={{
                              backgroundColor: "#f57c00",
                              color: "#fff !important",
                              "&:hover": { backgroundColor: "#e66f00" },
                            }}
                            onClick={() => props.onCorrectScreenshot(data.id)}
                            style={{ fontSize: "12px", padding: "5px", marginLeft: "5px", color: "#fff", backgroundColor: "#f57c00" }}
                          >
                            Correct
                          </Button>
                        )}

                        {props.onDeleteScreenshot && (
                            <IconButton
                              color="error"
                              size="small"
                              aria-label="Mark screenshot for replacement"
                              title="Mark for replacement"
                              disabled={data.can_replace}
                              sx={{ color: "#d32f2f !important" }}
                              style={{ color: "#d32f2f" }}
                            onClick={() => props.onDeleteScreenshot(data)}
                              style={{ marginLeft: "5px" }}
                          >
                              <DeleteOutlineIcon />
                            </IconButton>
                        )}

                        {!hideDelete && !props.onDeleteScreenshot && (
                          <>
                            <Button
                              id={`fade-button-${rowIndex}`}
                              aria-controls={
                                anchorEls[rowIndex]
                                  ? `fade-menu-${rowIndex}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                anchorEls[rowIndex] ? "true" : undefined
                              }
                              onClick={(event) =>
                                handleMenuClick(event, rowIndex)
                              }
                              style={{ padding: "5px" }}
                            >
                              <MoreVertIcon />
                            </Button>
                            <Menu
                              id={`fade-menu-${rowIndex}`}
                              MenuListProps={{
                                "aria-labelledby": `fade-button-${rowIndex}`,
                              }}
                              anchorEl={anchorEls[rowIndex]}
                              open={Boolean(anchorEls[rowIndex])}
                              onClose={() => handleMenuClose(rowIndex)}
                              TransitionComponent={Fade}
                            >
                              {data.is_deleted ? (
                                <MenuItem onClick={() => restore(data)}>
                                  Show Record
                                </MenuItem>
                              ) : (
                                <MenuItem onClick={() => softDelete(data)}>
                                  Hide Record
                                </MenuItem>
                              )}
                              <MenuItem onClick={() => forceDelete(data)}>
                                Remove Record
                              </MenuItem>
                            </Menu>
                          </>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
                {tableGroup.rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={showField.length + (manageRecord && actionBtnName !== false ? 1 : 0)} align="center">
                      No records for {tableGroup.title.toLowerCase()}.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          </React.Fragment>
          ))}
          <Pagination
            nextPage={nextPage}
            previousPage={previousPage}
            makeApiRequest={pageChangeRequest}
            getValueFromUrl={getValueFromUrl}
            dataApi={dataApi}
            totalCount={totalCount}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
    </>
  );
}

export default CrudManager;
